module.exports = __webpack_public_path__ + "img/Search.26e18b4.webp";